<template>
  <UikitListItem
    class="osk-products-filters-item-boolean"
    no-padding
  >
    <label
      class="osk-products-filters-item-boolean__label"
      @click="handleClick"
    >
      <span
        :class="{
          'osk-products-filters-item-boolean__label-text': true,
          'osk-products-filters-item-boolean__label-text_disabled': disabled,
        }"
      >
        {{ item.name }}
      </span>

      <div class="osk-products-filters-item-boolean__content">
        <UikitTooltip
          v-if="item.description"
          :title="item.name"
          @open="handleTooltipOpen"
        >
          {{ item.description }}
        </UikitTooltip>

        <UikitFormSwitch
          :model-value="modelValue"
          :name="item.code"
          no-label
          :disabled="disabled"
          @update:model-value="handleUpdate($event)"
        />
      </div>
    </label>
  </UikitListItem>
</template>

<script setup lang="ts">
import { BooleanFilter } from '~/restAPI/data-contracts';
import { AnalyticsEvents } from '~/types/analytics';

const { $addEvent } = useNuxtApp();

const props = defineProps<{
  modelValue: boolean
  item: BooleanFilter
  disabled?: boolean
  page?: string
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void,
}>();

function handleTooltipOpen() {
  $addEvent(AnalyticsEvents.FiltersLinkClick, {
    chapter: `info_${props.item.code}`,
    page: props.page,
  });
}

function handleClick(e: Event) {
  if (props.disabled) {
    e.preventDefault();
  }
}

function handleUpdate(value: boolean) {
  emits('update:modelValue', value);

  $addEvent(AnalyticsEvents.FiltersLinkClick, {
    chapter: props.item.code,
    id_chapter: String(value),
    page: props.page,
  });
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-products-filters-item-boolean {
  &__label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 52px;
    cursor: pointer;
    padding: 0 16px;
  }

  &__content {
    display: flex;
    align-items: center;
  }

  :deep(.osk-tooltip) {
    margin-right: 12.5px;
  }

  &__label-text {
    &_disabled {
      opacity: .3;
    }
  }
}
</style>
